import { render, staticRenderFns } from "./CurrenciesList.vue?vue&type=template&id=5191db2c&scoped=true&"
import script from "./CurrenciesList.vue?vue&type=script&lang=js&"
export * from "./CurrenciesList.vue?vue&type=script&lang=js&"
import style0 from "./CurrenciesList.vue?vue&type=style&index=0&id=5191db2c&prod&lang=scss&scoped=true&"
import style1 from "./CurrenciesList.vue?vue&type=style&index=1&id=5191db2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5191db2c",
  null
  
)

export default component.exports